import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { of } from 'rxjs';

/* We replace the TranslateService with a CustomTranslateService to prevent third-party
libraries (like DSW) from switching the app's locale. To change the language intentionally,
please use the forceUse method. */
@Injectable()
export class ProtectedTranslateService extends TranslateService {
  override use(lang: string) {
    return of({});
  }

  forceUse(lang: string) {
    return super.use(lang);
  }
}
